import React from 'react'
import { baseUrl } from '@fs/zion-config'
import { DocumentPhoto } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'

import BaseOfferCard from './BaseOfferCard'

export default function MemoriesCard() {
  const { t } = useTranslation()

  return (
    <BaseOfferCard
      data-testid="memories-card"
      title={t('apac.nlihp.offers.memories-card.heading', 'Capture Memories')}
      description={t(
        'apac.nlihp.offers.memories-card.subheading',
        'Preserve precious family photos, stories, and more.'
      )}
      Icon={DocumentPhoto}
      to={`${baseUrl}/memories`}
      external
      linkName="button: capture-memories: click"
    />
  )
}
